import { createContext, useContext, useMemo, type PropsWithChildren } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useAuth } from '../auth/AuthProvider'
import type { Tenant } from '../types'

interface TenantContextValue { tenant?: Tenant; tenantId?: string; loading: boolean }
const TenantContext = createContext<TenantContextValue | null>(null)

export function TenantProvider({ children }: PropsWithChildren) {
  const auth = useAuth()
  const tenantId = auth.profile.tenantId ?? undefined
  const query = useQuery({
    queryKey: ['tenant', tenantId],
    queryFn: () => api.tenant(tenantId!, auth.token),
    enabled: auth.authenticated && Boolean(tenantId),
  })
  const value = useMemo<TenantContextValue>(() => ({ tenant: query.data, tenantId, loading: query.isLoading }), [query.data, query.isLoading, tenantId])
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
}

export function useTenant() {
  const context = useContext(TenantContext)
  if (!context) throw new Error('useTenant deve estar dentro de TenantProvider')
  return context
}
